module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }